import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faYoutube,faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import googlePlayStoreImage from '../../assets/images/Google_Play_Store_badge_EN 1.png'

const Footer = () => {
    const navigate = useNavigate();

    const handleTermsOfConditions = () => {
        navigate('/terms-and-conditions')
    }

    const handleFaqs = () => {
        navigate('/faqs')
    }

    
    const handleContactUS = () => {
        navigate('/contact-us')
    }

    const handleRegistration = () => {
        navigate('/register')
    }

    const handleDashboard = () => {
        navigate('/dashboard')
    }

    const handleCancellationPolicy = () => {
        navigate('/cancellation-policy')
    }

    const handlePrivacy = () => {
        navigate('/privacy-policy')
    }

    const handleShipmentPolicy = () => {
        navigate('/shipping-policy')
    }

    const handleAboutUs = () => {
        navigate('/About-us');
    };

    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="footerr">
            <div className='link-yearr'>
                
                <a>© {currentYear} Selsmart All rights reserved.</a>
            </div>
        </footer>

    )
}

export default Footer;